import * as types from './mutation-types'


export const loadQvctAnswerType = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/qvct/answers/type/collection', data).then((response) => {
            commit(types.LOAD_QVCT_ANSWER_TYPE, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const storeQvctAnswerType = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/qvct/answers/type', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const updateQvctAnswerType = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`update/qvct/answers/type/${data.id}`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteQvctAnswerType = ({commit}, {id}) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`delete/qvct/answers/type/${id}`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
